/*
 * @Description: 支付管理-运费
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-10-17 11:26:15
 * @LastEditors: WangYuhan
 */

import { get, post, prefix } from './base';

// 获取支付运费列表
export function getWaybillSettlementList(data) {
  return post(`${prefix}waybillSettlement/pageSettlement`, data);
}

// 获取支付运费状态统计信息
export function getWaybillSettlementStatistics(params) {
  return get(`${prefix}waybillSettlement/count/payStatus`, params);
}

// 获取支付单批次统计信息
export function getSettlementBatchStatistics(params) {
  return get(`${prefix}waybillSettlement/batch/statistics`, params);
}

// 查询提交结算信息汇总
export function findSettlementCommitPage(params) {
  return post(`${prefix}waybillSettlement/findSettlementCommitPage`, params);
}
// 结算
export function commitTransaction(params) {
  return post(`${prefix}waybillSettlement/commitTransaction`, params);
}

// 拒绝
export function disclaimSettlement(params) {
  return post(`${prefix}waybillSettlement/v2/disclaimSettlement`, params);
}

// 重试
export function commitTransactionContinue(params) {
  return post(`${prefix}waybillSettlement/commitTransactionContinue`, params);
}

// 撤回接口
export function revocation(val) {
  return get(`${prefix}waybillSettlement/revocation`, val);
}

// 分油审核列表
export function oilApplyList(val) {
  return get(`${prefix}oil/applyList`, val);
}

// 分油审核统计信息
export function oilApplyCount(val) {
  return get(`${prefix}oil/applyCount`, val);
}

// 批量审核油款
export function verifyOilBatch(val) {
  return post(`${prefix}oil/verifyOilBatch`, val);
}

// 获取当前企业结算记录汇总
export function getSettlementCollectInfoByBid(params) {
  return post(`${prefix}settlementCollect/getSettlementCollectInfoByBid`, params);
}

// 获取该月份结算汇总信息
export function getSettlementSumAll(val) {
  return get(`${prefix}settlementCollect/getSettlementSumAll`, val);
}

// 导出结算记录
export const waybillSettlementExportUrl = `${prefix}waybillSettlement/export/SettlementExcel`;

// 导出分油审核记录
export const oilApplyExportUrl = `${prefix}oil/exportApplyPayList`;

// 加油记录导出
export const oilUseRecordListExport = `${prefix}oil/oilUseRecordListExport`;

// 油款钱包变动导出
export const oilTranChangeListExport = `${prefix}oil/oilTranChangeListExport`;

export const oilTranChangeListExportForLs = `${prefix}oil/oilTranChangeListExportForLs`;
// 油款钱包变动明细
export function oilTranChangeList(val) {
  return get(`${prefix}oil/oilTranChangeList`, val);
}

// 油款钱包变动明细统计
export function oilTranChangeListCount(val) {
  return get(`${prefix}oil/oilTranChangeListCount`, val);
}

// 油款字典表
export function oilDict(val) {
  return get(`${prefix}oil/oilDict`, val);
}

// 加油记录
export function oilUseRecordList(val) {
  return get(`${prefix}oil/oilUseRecordList`, val);
}

// 加油记录统计
export function oilUseRecordListCount(val) {
  return get(`${prefix}oil/oilUseRecordListCount`, val);
}
// 查询油品
export function getOilType(val) {
  return get(`${prefix}oil/getOilType`, val);
}

// 服务费返还列表
export function oneTicketRebatelist(params) {
  return get(`${prefix}admin/oneTicket/rebate/list`, params);
}

// 服务费返还金额
export function oneTicketRebateCount(params) {
  return get(`${prefix}admin/oneTicket/rebate/count`, params);
}

// 查询充值交易列表
export function queryRechargeList(params) {
  return get(`${prefix}openAccount/queryRechargeList`, params);
}

// 查询提现交易列表
export function queryWithdrawList(params) {
  return get(`${prefix}openAccount/queryWithdrawList`, params);
}

// 支付油款-待支付/已拒绝列表
export function pageSettlementByOil(params) {
  return post(`${prefix}waybillSettlement/pageSettlementByOil`, params);
}

// 支付油款-已完成列表
export function rechargeRecordsByChannel(params) {
  return get(`${prefix}wanjinyou/rechargeRecordsByChannel`, params);
}

// 支付油款-列表统计
export function payStatusByOil(params) {
  return get(`${prefix}waybillSettlement/count/payStatusByOil`, params);
}

// 获取子分类列表（全局）
export function getChildList(params) {
  return get(`${prefix}setting/getChildList`, params);
}
